const MobileMenuToggle = ({isActive, setIsActive}) => {
    return (
        <button className={`mobile-menu-toggle hamburger hamburger--stand ${isActive ? 'is-active' : ''}`} onClick={() => setIsActive(!isActive)}>
            <div className="hamburger-icon-wrap">
                <span className="hamburger-icon"></span>
            </div>
        </button>
    )
}

export default MobileMenuToggle